import Fail from '../Icons/svg/UpdateFailGray.svg'
import Success from '../Icons/svg/UpdateSuccessGray.svg'
import Box from '@mui/material/Box'
import Snackbar from '@mui/material/Snackbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Deletion from '../Icons/svg/snackbar/deletion.svg'
import Activation from '../Icons/svg/snackbar/activation.svg'
import Suspension from '../Icons/svg/snackbar/suspension.svg'

const messageStyles = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  '& img': {
    marginRight: '15px',
    width: '22px',
    '& .st1': { fill: 'brick' }
  },
  '& p': { margin: 0 }
}

const snackBarMessage = (severity, message) => {
  const messageList = !!message ? message : ''
  const imageList = {
    success: Success,
    fail: Fail,
    activation: Activation,
    suspension: Suspension,
    deletion: Deletion
  }

  return (
    <Box sx={messageStyles}>
      <img
        alt="SnackBarImage"
        src={imageList[severity] || imageList['success']}
        width={'22px'}
        height={'22px'}
      />
      <div>
        {messageList.split('\n').map((message, i) => (
          <p key={i}>{message}</p>
        ))}
      </div>
    </Box>
  )
}

const FeedbackSnackbar = ({ snackbar, setSnackbar }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSnackbar({ ...snackbar, isOpen: false })
  }

  return (
    <Snackbar
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={handleClose}
      open={snackbar.isOpen}
      autoHideDuration={3000}
      sx={(theme) => ({
        '& > div': {
          backgroundColor: theme.palette.tertiary.accent,
          borderRadius: '10px'
        }
      })}
      message={snackBarMessage(
        snackbar.severity,
        snackbar.message
      )}
    />
  )
}

export default FeedbackSnackbar
